import { useSyncExternalStore } from 'react';

/**
 * Store global mínimo (vanilla + useSyncExternalStore) para el modal de upsell
 * que se abre al superar una cuota del plan (error `PLAN_QUOTA_EXCEEDED`).
 *
 * No usamos zustand porque no está en las deps del proyecto; este patrón cubre
 * el único estado UI que necesitamos (open + details) con la misma ergonomía.
 *
 * IMPORTANTE (anti-ciclo): este módulo NO importa nada de `lib/query-client`.
 * `query-client.ts` importa `openPlanLimit` de aquí — la dependencia va en un
 * solo sentido, así que no hay ciclo de imports.
 */

let state = { open: false, details: null };
const listeners = new Set();

function emit() {
  for (const listener of listeners) listener();
}

/** Abre el modal con los `details` del error (`{ resource, usage, limit, plan }`). */
export function openPlanLimit(details) {
  state = { open: true, details: details ?? null };
  emit();
}

/** Cierra el modal (mantiene los details hasta la próxima apertura no importa). */
export function closePlanLimit() {
  state = { open: false, details: null };
  emit();
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return state;
}

/** Hook de React para leer el estado del modal en el componente global. */
export function usePlanLimitStore() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
